import axios from 'axios';

const state = {
    data: null,
    isLoading: false,
    error: null
};

export const mutationTypes = {
    getResearchStart: '[research] Get data start',
    getResearchSuccess: '[research] Get data success',
    getResearchFailure: '[research] Get data failure',
    getResearchMoreData: '[research] Get more data'
};

export const researchActionTypes = {
    getResearch: '[research] Get data',
    getMoreData: '[research] Get more data'
};

const mutations = {
    [mutationTypes.getResearchStart](state) {
        state.isLoading = true;
    },
    [mutationTypes.getResearchSuccess](state, payload) {
        state.isLoading = false;
        state.data = payload;
    },
    [mutationTypes.getResearchFailure](state) {
        state.isLoading = false;
    },
    [mutationTypes.getResearchMoreData](state, payload) {
        state.isLoading = false;
        state.data.data = state.data.data.concat(payload.data);
    },
};

const actions = {
    [researchActionTypes.getResearch](context, { apiUrl, searchValue }) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.getResearchStart);
            axios.get(apiUrl + searchValue)
                .then((response) => {
                    context.commit(mutationTypes.getResearchSuccess, response.data);
                    resolve(response.data);
                })
                .catch(() => {
                    context.commit(mutationTypes.getResearchFailure);
                });
        });
    },

    [researchActionTypes.getMoreData](context, { apiUrl, searchValue }) {
        return new Promise((resolve) => {
            context.commit(mutationTypes.getResearchStart);
            axios.get(apiUrl + searchValue)
                .then((response) => {
                    context.commit(mutationTypes.getResearchMoreData, response.data);
                    resolve(response.data);
                })
                .catch(() => {
                    context.commit(mutationTypes.getResearchFailure);
                });
        });
    }
};

export default {
    state,
    actions,
    mutations
};
